import { addError, AddErrorProps } from '@/global/plugins/observability'
import { useEffect } from 'react'

export interface UseAddErrorProps extends Omit<AddErrorProps, 'error'> {
  error?: Error | null
}

export const useAddError = ({ error, ...rest }: UseAddErrorProps) => {
  useEffect(() => {
    if (error) {
      addError({ error, ...rest })
    }
  }, [error, rest])
}
